import React from "react"
import { DecimalInput } from 'react-hichestan-numberinput'

export default ({ touched, errors, setFieldValue, values, handleBlur }) => (
  <div className="row display-flex">
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">

      <fieldset className="fieldset">
        <legend>تعداد کاغذ دکور کشیده ‌شده</legend>

        <div className="row">
          <div className="form-inline">

            <div className="col-md-12 col-sm-12">
              <strong style={{ fontSize: 18, backgroundColor: "rgb(198, 214, 198)", padding: '0 70px' }}>{values.extraDescription}</strong>
              {/* <DecimalInput type='tel'
                autoFocus={true}
                value={values.extraDescription}
                disabled
                className="text-input"
              /> */}
            </div>

          </div>
        </div>



      </fieldset>

    </div>

  </div>
);